/* import __COLOCATED_TEMPLATE__ from './invalid-browser-message.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();